var PredefinedTemplates = /* @__PURE__ */ ((PredefinedTemplates2) => {
  PredefinedTemplates2["freeForm"] = "freeForm";
  PredefinedTemplates2["AB"] = "AB";
  PredefinedTemplates2["flashResalt"] = "flashResalt";
  PredefinedTemplates2["dataCollection"] = "dataCollection";
  PredefinedTemplates2["preAA"] = "preAA";
  PredefinedTemplates2["targeted"] = "targeted";
  PredefinedTemplates2["seedFinder"] = "seedFinder";
  PredefinedTemplates2["stagedExposure"] = "stagedExposure";
  PredefinedTemplates2["externalAB"] = "externalAB";
  PredefinedTemplates2["seedFinderRampUp"] = "seedFinderRampUp";
  PredefinedTemplates2["twoIterationDataCenterAndSeedFinderRampUp"] = "twoIterationDataCenterAndSeedFinderRampUp";
  PredefinedTemplates2["dataCenterRampUp"] = "dataCenterRampUp";
  PredefinedTemplates2["dataCenterRampUpAmericas"] = "dataCenterRampUpAmericas";
  PredefinedTemplates2["dataCenterRampUpEurope"] = "dataCenterRampUpEurope";
  PredefinedTemplates2["dataCenterRampUpAsia"] = "dataCenterRampUpAsia";
  PredefinedTemplates2["flashResaltRampUp"] = "flashResaltRampUp";
  PredefinedTemplates2["galaxyInterleaving"] = "galaxyInterleaving";
  return PredefinedTemplates2;
})(PredefinedTemplates || {});
export {
  PredefinedTemplates
};
//# sourceMappingURL=ExperimentTemplate.js.map
